import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../store';
import { getFormState } from '../../store/app/selectors';
import { getGlobalItemLists } from '../../store/icf/selectors';
import { selectProduct, unselectProduct } from '../../store/products';
import { getAllProducts, getSelectedProduct } from '../../store/products/selectors';
import { SINGLE_WALL } from '../../utils';
import { sendInsightsEvent } from '../../utils/insights/sendInsights';
import emptySolutions from '../../utils/pax/emptySolutions';
import emptySolutionsForCornerGuide from '../../utils/pax/emptySolutionsForCornerGuide';
import { filterTypes } from '../../utils/pax/filterTypes';
import { buildAngledImage, buildFlatImage } from '../../utils/results';
import { ProductListRecommendations } from '../ProductList/ProductListRecommendations';
import { ProductsSheet } from './ProductsSheet';
import { StyledResults } from './styles';
/**
 * Check if the selected product exists in the list of empty solutions
 * @param selectedProduct The selected product
 * @returns True if the product is an empty solution, otherwise false.
 */
const isEmptySolution = (selectedProduct) => {
    const isEmptySingle = emptySolutions.some(solution => {
        const matchingVpc = solution.vpc === selectedProduct?.icf.vpc;
        const matchingSlidingVpc = solution.slidingDoor === selectedProduct?.icf.vpc;
        return matchingVpc || matchingSlidingVpc;
    });
    const isEmptyCorner = emptySolutionsForCornerGuide.some(solution => {
        const matchingVpc = solution.vpc === selectedProduct?.icf.vpc;
        return matchingVpc;
    });
    return isEmptySingle || isEmptyCorner;
};
const orderedImageTypes = ['open-design-image', 'main-design-image', 'open-design-image-angled'];
const getImagesForProduct = (selectedProduct, wall) => {
    if (!selectedProduct) {
        return [];
    }
    let images = [];
    const productImages = selectedProduct.icf.images;
    // We want some of the images in a specific order
    let orderedImages = [];
    if (wall === SINGLE_WALL) {
        orderedImages = [buildFlatImage(productImages), buildAngledImage(productImages)];
    }
    else {
        orderedImages = [buildAngledImage(productImages), buildFlatImage(productImages)];
    }
    // Insert the ordered images
    orderedImages.forEach(img => img && images.push(img));
    // Push any remaining images from the VPC after the ones we inserted in order above.
    images.push(...productImages.filter(pImg => !orderedImageTypes.includes(pImg.typeCode)));
    if (isEmptySolution(selectedProduct) && images.length > 1) {
        // The empty solution will contain identical images for main and open design image,
        // therefore we remove one of them.
        images = images.filter(img => img.typeCode !== 'main-design-image');
    }
    return images;
};
const Products = (props) => {
    const [visible, setVisible] = useState(false);
    const dispatch = useAppDispatch();
    const products = useSelector(getAllProducts);
    const globalItemLists = useSelector(getGlobalItemLists);
    const selectedProduct = useSelector(getSelectedProduct);
    const formState = useSelector(getFormState);
    // TODO: ugly, refactor
    const onReadMore = (icf) => {
        const articles = globalItemLists.find(item => item.vpc === icf.vpc)?.itemList ?? icf.vpcData.itemList ?? [];
        // Preferably don't use the vpcData.itemList directly here, because it can contain local products not available
        // See https://i-p-e-x.atlassian.net/browse/GUID-116 for reference.
        const mappedArticles = articles
            .map(item => {
            const guidaProduct = products.find(product => item.id === product.id);
            // Append the GuidaProduct data to the article
            return {
                ...guidaProduct,
                ...item
            };
        })
            .filter(item => item.product);
        const selectedArticles = mappedArticles.filter(item => !filterTypes(item.product?.content?.mainTypeName));
        const homeDeliveryProducts = selectedArticles.map(item => ({
            id: item.id,
            type: item.type
        }));
        const shoppingProducts = selectedArticles.map(item => ({
            quantity: item.quantity,
            product: item.product
        }));
        const storeProducts = shoppingProducts.map(item => item.product);
        const icfData = {
            shoppingProducts: shoppingProducts,
            products: storeProducts,
            homeDeliveryProducts: homeDeliveryProducts,
            icf: {
                vpc: icf.vpcData.configurationId,
                images: icf.vpcData.imageUrl
            }
        };
        const numberOfArticles = articles.reduce((acc, curr) => {
            return acc + curr.quantity;
        }, 0);
        sendInsightsEvent('showMe', 'open_whats_included', {
            vpc: icf.vpcData.configurationId,
            numberOfArticles
        });
        setVisible(true);
        dispatch(selectProduct(icfData));
    };
    const closeSheet = () => {
        dispatch(unselectProduct());
        setVisible(false);
    };
    const images = getImagesForProduct(selectedProduct, formState.wall);
    return (_jsxs(StyledResults, { children: [_jsx(ProductListRecommendations, { isMobile: props.isMobile, onReadMore: art => onReadMore(art) }), _jsx(ProductsSheet, { images: images, visible: visible, onSheetClose: closeSheet, selectedProduct: selectedProduct })] }));
};
export default Products;
//# sourceMappingURL=Products.js.map